import React from 'react';
import { SubTitle, styled } from '@teko/ds-desktop';
import { getTrackingData } from '@teko/tracking';
import { convertMegaMenu } from '../../helpers/megaMenu.es.js';
import { TekoLink } from '../TekoLink/TekoLink.es.js';
import { EnhancedImage } from '../EnhancedImage/EnhancedImage.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const MEGA_MENU_BANNER_WIDTH = "14.625rem";
const MAX_MENU_ITEMS = 15;
const MEGA_MENU_TEXT_REGION = "megaMenuText";
const MENU_LEVEL_SEPARATOR = " | ";
const buildMenuContentName = (...names) => names.filter(Boolean).join(MENU_LEVEL_SEPARATOR);
const MenuPanel = ({
  menu,
  activeMenu,
  className,
  type,
  onClickMenuItem
}) => {
  var _a, _b, _c, _d;
  if (!menu.length)
    return null;
  const col = (item, rootName) => {
    return item.map((it, index) => /* @__PURE__ */ React.createElement(MenuLv2, {
      key: it.name + `-${index}`,
      onClick: onClickMenuItem
    }, /* @__PURE__ */ React.createElement(TekoLink, __spreadValues({}, it.link), /* @__PURE__ */ React.createElement(SubTitle, __spreadValues({
      level: 1,
      line: 1,
      color: "primary500",
      marginBottom: "s8"
    }, getTrackingData({
      isTrackContent: true,
      regionName: MEGA_MENU_TEXT_REGION,
      contentName: buildMenuContentName(rootName, it.name)
    })), it.name)), it.children.map((subItem, index2) => /* @__PURE__ */ React.createElement(TekoLink, __spreadProps(__spreadValues({}, subItem.link), {
      key: index2
    }), /* @__PURE__ */ React.createElement(Text, __spreadValues({}, getTrackingData({
      isTrackContent: true,
      regionName: MEGA_MENU_TEXT_REGION,
      contentName: buildMenuContentName(rootName, it.name, subItem.name)
    })), subItem.name)))));
  };
  return /* @__PURE__ */ React.createElement(MenuPanelWrapper, {
    isDisplay: !!activeMenu && (!!((_a = activeMenu.banner) == null ? void 0 : _a.src) || !!((_b = activeMenu.children) == null ? void 0 : _b.length)),
    className
  }, menu.slice(0, MAX_MENU_ITEMS).map((menuItem, index) => {
    const getMenuColumns = () => {
      var _a2;
      let totalCols = 6;
      if (type === "vertical")
        totalCols--;
      if ((_a2 = menuItem == null ? void 0 : menuItem.banner) == null ? void 0 : _a2.src)
        totalCols--;
      return totalCols;
    };
    const newMenu = convertMegaMenu(menuItem, getMenuColumns());
    return /* @__PURE__ */ React.createElement(MenuItemsWrapper, {
      key: index,
      isActive: menuItem === activeMenu
    }, newMenu.map((menu2, index2) => /* @__PURE__ */ React.createElement(Column, {
      key: index2
    }, col(menu2.column, menuItem.name))));
  }), ((_c = activeMenu == null ? void 0 : activeMenu.banner) == null ? void 0 : _c.src) && /* @__PURE__ */ React.createElement(TekoLink, __spreadValues({}, (_d = activeMenu.banner) == null ? void 0 : _d.link), /* @__PURE__ */ React.createElement(EnhancedImage, {
    src: activeMenu.banner.src,
    width: MEGA_MENU_BANNER_WIDTH,
    height: "100%",
    googleImageParams: {
      width: 400
    },
    tracking: getTrackingData({
      regionName: "megaMenuBanner",
      isTrackContent: true
    })
  })));
};
const Text = styled.div(({ theme }) => `
  color: ${theme == null ? void 0 : theme.colors.textPrimary};
  margin-bottom: 4px;
  &:hover {
    color: ${theme == null ? void 0 : theme.colors.primary500};
  }
`);
const MenuPanelWrapper = styled.div(({ theme, isDisplay }) => `
  background-color: ${theme == null ? void 0 : theme.colors.white};
  display: ${isDisplay ? "flex" : "none"};
`);
const MenuItemsWrapper = styled.div(({ theme, isActive }) => `
  display: ${isActive ? "flex" : "none"};
  flex: 1;
  padding: ${theme == null ? void 0 : theme.spacing.s12};
`);
const MenuLv2 = styled.div`
  margin-bottom: 1.5rem;
`;
const Column = styled.div`
  width: 25%;
  padding: 0 8px;
`;

export { MAX_MENU_ITEMS, MenuPanel };
